import { CommonModule } from '@angular/common';
import { Component, OnDestroy, ViewChildren, QueryList, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonInput, IonHeader, IonContent, IonButton, IonNote, IonToolbar, IonTitle, IonIcon, IonButtons , IonLabel,IonItem ,IonCardContent,IonCard,IonCardHeader } from '@ionic/angular/standalone';
import { ModalController } from '@ionic/angular/standalone';
import { ToastService } from 'src/app/core/services/toaster.service';
import { addIcons } from 'ionicons';
import { callOutline, shieldCheckmarkOutline, closeOutline, arrowForwardOutline, checkmarkOutline,storefrontOutline,arrowForward,mail ,timeOutline,rocketOutline,analyticsOutline,shieldCheckmark } from 'ionicons/icons';
import { SellerFlow, SESSION_STORAGE_KEYS, TENANT_DETAILS } from 'src/app/core/types/types';
import { SellerService } from 'src/app/core/services/seller.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
  standalone: true,
  imports: [
    // IonButtons,
     IonIcon, 
    IonInput,
    // IonHeader,
    IonContent,
    IonButton,
    IonNote,
    // IonToolbar,
    // IonTitle,
    IonButton,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    // IonLabel,
    IonItem,
    IonCard,IonCardContent,
    IonCardHeader
    
  ]
})
export class OtpVerificationComponent implements OnDestroy, OnInit {
  regsistrationType: 'login' | 'register' = 'register';
  @ViewChildren('otpInput') otpInputs!: QueryList<IonInput>;
  
  phoneForm: FormGroup;
  otpDigits: string[] = new Array(6).fill('');
  otpSent = false;
  timeLeft = 30;
  canResend = false;
  isValidOtp = false;
  private timerInterval: any;
  

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private sellerService : SellerService,
    private sharedService: SharedService,
    private activatedRoute : ActivatedRoute,
    private router : Router
  ) {
    this.phoneForm = this.fb.group({
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)
      ]]
    });
    addIcons({closeOutline,callOutline,arrowForwardOutline,shieldCheckmarkOutline,checkmarkOutline,storefrontOutline,arrowForward,mail ,timeOutline,rocketOutline,analyticsOutline,shieldCheckmark });
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res: any) => {
      const tenantDetails: TENANT_DETAILS = {
        COMPANY_ID: res?.company_id || this.sellerService.defaultTenantCompanyId,
        FE_URL: res?.url ? res.url.replace('register', 'login') : this.sellerService.defaultTenantFEUrl,
        BACK_END_URL: this.sellerService.BACK_END_URL
      }
      if(res?.type)  this.regsistrationType = res.type
      this.sharedService.setDataToSessionStorage({ key: SESSION_STORAGE_KEYS.TENANT_DETAILS, data: tenantDetails }, 'SESSION')
    })
    this.activatedRoute.queryParams.subscribe((res:any)=>{
    })
  }

  async sendOTP() {
    if (this.phoneForm.valid) {
      const phone = this.phoneForm.get('phoneNumber')?.value;
      this.sellerService.sendOTP(phone).subscribe((res:any)=>{
        this.otpSent = true;
        this.startTimer();
        this.otpDigits = new Array(6).fill('');
      })
    }
  }

  startTimer() {
    this.timeLeft = 30;
    this.canResend = false;
    
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.canResend = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  onOtpInput(event: any, index: number) {
    const input = event.target.value;
    
    if (input && index < 5) {
      this.otpInputs.get(index + 1)?.setFocus();
    }
    
    this.validateOtp();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      this.otpInputs.get(index - 1)?.setFocus();
    }
  }

  validateOtp() {
    this.isValidOtp = this.otpDigits.every(digit => /^\d$/.test(digit));
  }

  async verifyOTP() {
    if (this.isValidOtp) {
      const tenantDetails = this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.TENANT_DETAILS) as TENANT_DETAILS
      const otp = this.otpDigits.join('');
      const phone = this.phoneForm.get('phoneNumber')?.value;
      this.sellerService.verifyOTP({phone,otp ,company_id : tenantDetails.COMPANY_ID}).subscribe((res:any)=>{
        // const flow = res.data.isApproved && res.data.isProfileCompleted ? SellerFlow.PUBLISHED : SellerFlow.DRAFT
        this.sharedService.handleFlow({ seller_id : res?.data?.seller_id , token : res?.data?.token || 'randomtoken' , isApproved : res?.data?.sellerForm?.isApproved || 0, isProfileCompleted : res?.data?.sellerForm?.isProfileCompleted ||0 , data : res?.data || {sellerForm : {phone : phone} }});
      })
    }
  }



  moveToLanding(){
    this.router.navigate(['/home'])
  }

  async startSelling(type: 'register' | 'login') {
    this.router.navigate(['seller-registration'], { queryParams: { type } })
  }

  openWindow(url:string){
    window.open(url, '_blank')
  }

  resendOTP() {
    if (this.canResend) {
      this.sendOTP()
    }
  }

  changeNumber() {
    this.otpSent = false;
    this.otpDigits = new Array(6).fill('');
    this.phoneForm.reset();
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
  signinWithSamhita(){
    this.toastService.presentToast('Signing in with Samhita currently not available','warning')
  }
  register(){
    this.router.navigate(['seller-registration'], { queryParams: { type: 'register' } });
  }
  login(){
    this.router.navigate(['seller-registration'], { queryParams: { type: 'login' } });
  }
}